<template>
  <div class="select-problem">
    <p class="os-font-14-500">选择故障类型</p>
    <div v-if="hasProblemList" class="problem-list">
      <ul class="os-font-14-400">
        <li
          v-for="(problem, pIndex) in apiProblemList"
          :key="`problem-${pIndex}`"
          :class="{
            multiple: problem.isMultiple,
            active: problem.isActive
          }"
        >
          <p v-if="!problem.isMultiple" class="title" @click="selectedProblem(problem)">
            {{ problem.quesSubList[0].name }}
          </p>
          <div v-else :class="{ expanded: problem.isExpanded }">
            <p class="title" @click="toggle(problem)">
              {{ problem.activeName }}
            </p>
            <img
              :src="require('@/assets/img/common/icon.png')"
              class="toggle-icon"
              @click="toggle(problem)"
            />
            <transition name="fade">
              <div v-if="problem.isExpanded">
                <p
                  v-for="(subProblem, sIndex) in problem.quesSubList"
                  :key="`subProblem-${sIndex}`"
                  :class="{
                    active: subProblem.isActive
                  }"
                  @click="selectedSubProblem(problem, sIndex)"
                >
                  {{ subProblem.name }}
                </p>
              </div>
            </transition>
          </div>
        </li>
      </ul>
    </div>
    <div v-else-if="noProblemList" class="no-problem-list os-font-14-400">
      <p>
        当前设备型号暂无可用的故障数据<br />请联系<a
          href="https://kefu.vivo.com.cn/robot-vivo/pcChat.html"
          >官方客服</a
        >
      </p>
    </div>
    <div v-else class="not-selected-model">
      <p class="os-font-14-400">请先选择设备</p>
    </div>
  </div>
</template>

<script>
import API from 'views/repair/base/api'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'selectProblem',
  data() {
    return {
      autoSelectedFaultId: '',
      noProblemList: false,
      hasProblemList: false,
      currentProblems: [],
      // 接口返回的数据结构，不包含 isActive | isMultiple | isExpanded
      apiProblemList: [
        {
          isActive: false,
          isMultiple: false,
          isExpanded: false,
          faultTypeId: null,
          faultTypeName: null,
          quesSubList: [
            {
              isActive: null,
              faultTypeId: null,
              id: null,
              name: null,
              componentPrices: [
                {
                  componentName: null,
                  id: null,
                  price: null
                }
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapState('repair', [
      'repairType',
      'selectedModel',
      'problemList',
      'activeProblems',
      'fromSupport'
    ])
  },
  mounted() {
    // 尝试用全局变量中读取故障类型列表
    if (this.problemList.length > 0) {
      this.apiProblemList = this.problemList
    } else if (this.selectedModel.id) {
      this.getFaults()
    }

    // 尝试用全局变量中读取选中的故障类型列表
    if (this.activeProblems.length > 0) {
      this.currentProblems = this.activeProblems
      this.noProblemList = false
      this.hasProblemList = true
    }
  },
  created() {
    this.autoSelectedFaultId = this.$route.query.faultId || ''
  },
  watch: {
    // 监听维修类型的变化
    repairType(val) {
      if (val) {
        this.getFaults()
      }
    },
    // 监听用户选择机型的变化
    selectedModel(val) {
      if (val.id) {
        this.currentProblems = []
        this.getFaults()
      }
    },
    currentProblems(val) {
      let componentPriceData = {
        totalPrice: 0,
        priceList: []
      }
      let selectedProblemList = {
        id: '',
        name: ''
      }
      if (val && val.length > 0) {
        val.forEach((item, index) => {
          selectedProblemList.id += index === 0 ? `${item.id}` : `,${item.id}`
          selectedProblemList.name += index === 0 ? `${item.name}` : `,${item.name}`
          if (item.componentPrices && item.componentPrices.length > 0) {
            item.componentPrices.forEach(component => {
              // 配件列表
              componentPriceData.priceList.push(component)

              // 尝试将price转换为数字
              let numericPrice = Number(component.price)

              // 检查转换后的price是否是NaN，如果是NaN，则设置为0
              if (Number.isNaN(numericPrice)) {
                numericPrice = 0
              }

              // 添加配件总价格
              componentPriceData.totalPrice += numericPrice
            })
          }
        })

        this.SET_PROBLEM_LIST(this.apiProblemList)
        this.SET_ACTIVE_PROBLEM_LIST(this.currentProblems)
        // 将故障类型名称存在到全局变量
        this.SET_SELECTED_PROBLEM_LIST(selectedProblemList)
        // 将配件价格存储到全局变量
        this.SET_COMPONENT_PRICES_DATA(componentPriceData)
        this.SET_BASE_NEXT_CHECK(true)
      } else {
        // 清空数据
        this.RESET_STATE('problemList')
        this.RESET_STATE('activeProblems')
        this.RESET_STATE('selectedProblemList')
        this.RESET_STATE('componentPriceData')
        this.SET_BASE_NEXT_CHECK(false)
      }
    }
  },
  methods: {
    ...mapMutations('repair', [
      'SET_COMPONENT_PRICES_DATA',
      'SET_SELECTED_PROBLEM_LIST',
      'SET_BASE_NEXT_CHECK',
      'SET_PROBLEM_LIST',
      'SET_ACTIVE_PROBLEM_LIST',
      'RESET_STATE'
    ]),
    getFaults() {
      API.getFaults({
        data: {
          type: this.repairType,
          productId: this.selectedModel.id
        }
      })
        .then(res => {
          if (res.code === 0) {
            this.processData(res.data)
          } else {
            console.log(res.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    processData(data) {
      this.apiProblemList = data || []
      // 判断接口返回是否有数据
      if (this.apiProblemList && this.apiProblemList.length > 0) {
        this.apiProblemList.forEach((item, index) => {
          // 为手动添加的属性设置监听
          this.$set(item, 'isActive', false)
          this.$set(item, 'isExpanded', false)
          this.$set(item, 'isMultiple', Boolean(item.quesSubList && item.quesSubList.length > 1))

          if (item.quesSubList && item.quesSubList.length > 1) {
            this.$set(item, 'activeName', item.faultTypeName)
          } else if (this.fromSupport) {
            // 电池场景化跳转过来的自动选中电池相关的一级故障类型
            if (/电池/i.test(item.faultTypeName)) {
              this.selectedProblem(item)
            }
          }

          item.quesSubList &&
            item.quesSubList.forEach((subItem, sIndex) => {
              this.$set(subItem, 'isActive', false)

              // 根据 url 参数中的故障类型 ID 自动选中故障类型
              if (this.autoSelectedFaultId && String(subItem.id) === this.autoSelectedFaultId) {
                if (item.quesSubList.length > 1) {
                  this.apiProblemList[index].isExpanded = true
                  this.selectedSubProblem(this.apiProblemList[index], sIndex)
                } else {
                  this.selectedProblem(this.apiProblemList[index])
                }
              }
            })
        })
        this.noProblemList = false
        this.hasProblemList = true
      } else {
        // 接口无数据返回时，清空缓存
        this.RESET_STATE('problemList')
        this.RESET_STATE('activeProblems')
        // 展示兜底样式
        this.noProblemList = true
        this.hasProblemList = false
      }
    },
    toggle(problem) {
      problem.isExpanded = !problem.isExpanded
    },
    // 单个故障类型选中逻辑
    selectedProblem(problem) {
      problem.isActive = !problem.isActive
      problem.quesSubList[0].isActive = problem.isActive

      if (problem.isActive) {
        this.currentProblems.push(problem.quesSubList[0])
      } else {
        this.currentProblems = this.currentProblems.filter(activeItem => {
          return activeItem.id !== problem.quesSubList[0].id
        })
      }
    },
    // 多个故障类型选中逻辑
    selectedSubProblem(problemList, sIndex) {
      let subProblemList = problemList.quesSubList

      subProblemList.forEach((item, i) => {
        // 清空该分类下所有二级故障类型
        this.currentProblems = this.currentProblems.filter(activeItem => {
          return activeItem.id !== item.id
        })

        if (i === sIndex) {
          item.isActive = !item.isActive
          problemList.isActive = item.isActive

          // 一个分类只选中一个二级故障类型
          problemList.isActive && this.currentProblems.push(item)
          problemList.activeName = problemList.isActive
            ? `${problemList.faultTypeName} - ${item.name}`
            : `${problemList.faultTypeName}`
        } else {
          item.isActive = false
        }
      })

      this.toggle(problemList)
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
